import {
  type AuthError,
  getAuthError,
  getAuthResult,
  isAuth0SessionInformationFetched,
  isAuthenticated,
} from "../../services/authentication/authReducer";
import type { StoreState } from "../../store/storeState";
import { useShallowEqualSelector } from "./useShallowEqualSelector";

interface StateProps {
  error: AuthError | null;
  isAuthenticated: boolean;
  redirectedFromCallbackUrl: boolean;
  sessionFetched: boolean;
}
const mapState = (state: StoreState): StateProps => {
  return {
    isAuthenticated: isAuthenticated(state),
    sessionFetched: isAuth0SessionInformationFetched(state),
    error: getAuthError(state),
    redirectedFromCallbackUrl:
      getAuthResult(state)?.redirectedFromCallbackUrl ?? false,
  };
};

export const useAuthState = () => {
  const { isAuthenticated, sessionFetched, error, redirectedFromCallbackUrl } =
    useShallowEqualSelector(mapState);

  return { isAuthenticated, sessionFetched, error, redirectedFromCallbackUrl };
};
